module.exports = __webpack_public_path__ + "static/media/whitelogo.48258ac3.png";